import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
    asyncGetParam,
    asyncGetFraudModeHistorical,
} from '../../../../../services/param.service';
import { Param, ParamHistorical } from '../../../../../shared/types/param';
import { FRAUD_MODE } from '../../../../../routes/paths';

export const useFraudModeDetail = () => {
    const [showHistorical, setShowHistorical] = useState(false);
    const navigate = useNavigate();
    const { idFraudMode } = useParams();
    const [loading, setLoading] = useState(false);
    const [fraudMode, setFraudMode] = useState<Param>();
    const [fraudModeHistorical, setFraudModeHistorical] =
        useState<ParamHistorical[]>();

    useEffect(() => {
        if (Boolean(idFraudMode)) {
            setLoading(true);
            asyncGetParam(idFraudMode)
                .then((fraudMode: any) => {
                    if (!fraudMode || !fraudMode.items) navigate(FRAUD_MODE);
                    setFraudMode(fraudMode?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idFraudMode]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetFraudModeHistorical(idFraudMode)
                .then((resp) => {
                    if (resp) setFraudModeHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        loading,
        fraudMode,
        fraudModeHistorical,
        showHistorical,
        setShowHistorical,
    };
};
